<mat-chip-listbox>
    <mat-chip-option
        selectable="false"
        class="st-status-chip"
        [matMenuTriggerFor]="listDropDownMenu"
        [disabled]="disabled()"
        [class.st-status-chip-valid]="required() && !internalValue()?.length"
        [class.st-status-chip-required]="required() && !internalValue()?.length"
        (keyup.space)="openMatMenu()"
        (keyup.enter)="openMatMenu()"
        (menuClosed)="valueChanged()"
        (menuOpened)="onMenuOpened()">
        <span>{{ displayValue() }} </span>
    </mat-chip-option>
</mat-chip-listbox>
<mat-menu
    #listDropDownMenu="matMenu"
    class="st-status-menu">
    <form
        [dir]="dir"
        (keydown.Tab)="onTabOrEscPress()"
        (keydown.Escape)="onTabOrEscPress()">
        <mat-form-field
            subscriptSizing="dynamic"
            appearance="fill">
            <mat-icon matPrefix>search</mat-icon>
            <input
                #searchBox
                type="text"
                matInput
                [placeholder]="webSearchLabel()"
                [formControl]="statusFilter"
                (keydown.arrowup)="onUpArrowPress()"
                (keydown.arrowdown)="onDownArrowPress()" />
        </mat-form-field>
        <mat-selection-list
            hideSingleSelectionIndicator
            multiple="false"
            [ngModel]="internalValue()"
            (selectionChange)="internalValueChanged($event)">
            <mat-list-option
                *ngFor="let item of filteredOptions | async"
                class="st-status-list-options"
                [value]="item">
                {{ getItemStatusLabel(item) }}
                <mat-icon class="st-status-list-options-icon">check</mat-icon>
            </mat-list-option>
        </mat-selection-list>
    </form>
</mat-menu>
